module.exports = __webpack_public_path__ + "img/bean.608441ff.png";